gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

// --------------------------------------------------------------------------
// Guarded DOM / Swiper helpers.
// Homepage sections are merchant-removable in the theme editor, so any lookup
// in this file can legitimately match nothing. A missing element must never
// throw, because an uncaught error here aborts every section defined below it.
// --------------------------------------------------------------------------
function coOn(selector, events, handler) {
  const nodes = document.querySelectorAll(selector);
  if (!nodes.length) return;
  const types = events.split(' ');
  nodes.forEach((el) => types.forEach((type) => el.addEventListener(type, handler)));
}

function coSwiperOn(swiper, event, handler) {
  if (!swiper || typeof swiper.on !== 'function') return;
  swiper.on(event, handler);
}

function coAutoplay(swiper, action) {
  if (!swiper || !swiper.autoplay || typeof swiper.autoplay[action] !== 'function') return;
  swiper.autoplay[action]();
}

function coSwiperReady(swiper) {
  return !!(swiper && swiper.el && swiper.slides && swiper.slides.length);
}
function coHandleStickyOnScroll(selector) {
  let lastScroll = window.scrollY;
  const el = document.querySelector(selector);
  if (!el) return;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll < lastScroll) {
      el.classList.add('co-sticky');
    } else {
      el.classList.remove('co-sticky');
    }
    lastScroll = currentScroll;
  });
}
coHandleStickyOnScroll('.co-home-5-left');
// ========================================================================================== HERO
let coSwiperTransition1 = 200;
let coSwiperTransition2 = 200;
let coSwiperTransition3 = 200;
let coSwiperTransition4 = 500;
let coSwiper1, coSwiper2, coSwiper3, coSwiper4;
let currentSlideIndex = 0;
let isInitializing = false;

function getCurrentSlideIndex() {
  if (coSwiper1 && coSwiper1.realIndex !== undefined) {
    return coSwiper1.realIndex;
  }
  return currentSlideIndex;
}

function initializeCoSwipers(container = document, preserveSlide = false) {
  if (isInitializing) return;
  isInitializing = true;
  
  if (preserveSlide) {
    currentSlideIndex = getCurrentSlideIndex();
  }
  
  if (coSwiper1) {
    coSwiper1.off('slideChange');
    coSwiper1.destroy(true, true);
  }
  if (coSwiper2) coSwiper2.destroy(true, true);
  if (coSwiper3) coSwiper3.destroy(true, true);
  if (coSwiper4) coSwiper4.destroy(true, true);
  
  setTimeout(() => {
    const slider1 = container.querySelector('.co-home-1-slider-1>.swiper');
    const slider2 = container.querySelector('.co-home-1-slider-2>.swiper');
    const slider3 = container.querySelector('.co-home-1-slider-3>.swiper');
    const slider4 = container.querySelector('.co-home-1-slider-4>.swiper');
    
    if (slider1) {
      // Create autoplay config - only enable if NOT in design mode
      const autoplayConfig = (window.Shopify && window.Shopify.designMode) ? false : {
        delay: 4000,
        disableOnInteraction: true,
      };
      
      coSwiper1 = new Swiper('.co-home-1-slider-1>.swiper', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true, },
        speed: coSwiperTransition1,
        loop: true,
        autoplay: autoplayConfig,
        watchSlidesProgress: true,
        initialSlide: preserveSlide ? currentSlideIndex : 0,
        navigation: {
          nextEl: '.co-home-1-nav-arrow-next',
          prevEl: '.co-home-1-nav-arrow-prev',
        },
      });
    }
    
    if (slider2) {
      coSwiper2 = new Swiper('.co-home-1-slider-2>.swiper', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true, },
        speed: coSwiperTransition2,
        watchSlidesProgress: true,
        allowTouchMove: false,
        initialSlide: preserveSlide ? currentSlideIndex : 0,
      });
    }
    
    if (slider3) {
      coSwiper3 = new Swiper('.co-home-1-slider-3>.swiper', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true, },
        speed: coSwiperTransition3,
        watchSlidesProgress: true,
        allowTouchMove: false,
        initialSlide: preserveSlide ? currentSlideIndex : 0,
      });
    }
    
    if (slider4) {
      coSwiper4 = new Swiper('.co-home-1-slider-4>.swiper', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true, },
        speed: coSwiperTransition4,
        watchSlidesProgress: true,
        allowTouchMove: false,
        initialSlide: preserveSlide ? currentSlideIndex : 0,
      });
    }
    
    if (coSwiper1) {
      if (preserveSlide && currentSlideIndex > 0) {
        setTimeout(() => {
          coSwiper1.slideToLoop(currentSlideIndex, 0);
          if (coSwiper2) coSwiper2.slideToLoop(currentSlideIndex, 0);
          if (coSwiper3) coSwiper3.slideToLoop(currentSlideIndex, 0);
          if (coSwiper4) coSwiper4.slideToLoop(currentSlideIndex, 0);
        }, 50);
      }
      
      coSwiper1.on('slideChange', () => {
        currentSlideIndex = coSwiper1.realIndex;
        if (coSwiper2) coSwiper2.slideToLoop(coSwiper1.realIndex);
        if (coSwiper3) coSwiper3.slideToLoop(coSwiper1.realIndex);
        if (coSwiper4) coSwiper4.slideToLoop(coSwiper1.realIndex);
      });
    }
    
    isInitializing = false;
  }, 100);
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const debouncedCustomizerInit = debounce(() => {
  initializeCoSwipers(document, true); 
}, 200);

document.addEventListener('DOMContentLoaded', () => {
  initializeCoSwipers(document, false);
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.co-home-1-slider-1, .co-home-1-slider-2, .co-home-1-slider-3, .co-home-1-slider-4')) {
      debouncedCustomizerInit();
    }
  });
  
  document.addEventListener('shopify:section:reorder', function(event) {
    debouncedCustomizerInit();
  });
  
  document.addEventListener('shopify:section:select', function(event) {
    if (event.target.querySelector('.co-home-1-slider-1, .co-home-1-slider-2, .co-home-1-slider-3, .co-home-1-slider-4')) {
      setTimeout(() => {
        if (coSwiper1 && !coSwiper1.destroyed) {
          coSwiper1.update();
          if (coSwiper2) coSwiper2.update();
          if (coSwiper3) coSwiper3.update();
          if (coSwiper4) coSwiper4.update();
        }
      }, 100);
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target.querySelector('.co-home-1-slider-1, .co-home-1-slider-2, .co-home-1-slider-3, .co-home-1-slider-4')) {
      currentSlideIndex = getCurrentSlideIndex();
    }
  });
}

window.addEventListener('resize', debounce(() => {
  if (coSwiper1 && !coSwiper1.destroyed) {
    coSwiper1.update();
    if (coSwiper2) coSwiper2.update();
    if (coSwiper3) coSwiper3.update();
    if (coSwiper4) coSwiper4.update();
  }
}, 250));
// ========================================================================================== SECTION 2 CULTURE CUP
const autoplayDelay2 = 0;

const coS2Swiper1 = new Swiper('.co-home-2-slider-1', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 400,
  loop: true,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  watchSlidesProgress: true,
  mousewheel: {
    forceToAxis: true,
  },
});

const coS2Swiper2 = new Swiper('.co-home-2-slider-2', {
  slidesPerView: 1,
  speed: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: true,
});

const coS2Swiper3 = new Swiper('.co-home-2-slider-3', {
  slidesPerView: 1,
  speed: 400,
  effect: 'fade',
  watchSlidesProgress: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: true,
});

coSwiperOn(coS2Swiper1, 'slideChange', () => {
  if (!coSwiperReady(coS2Swiper2) || !coSwiperReady(coS2Swiper3)) return;
  const mainIndex = coS2Swiper1.realIndex;
  const totalSlider2Slides = coS2Swiper2.slides.length;
  const recycledIndex = mainIndex % totalSlider2Slides;
  coS2Swiper2.slideToLoop(recycledIndex);
  coS2Swiper3.slideToLoop(mainIndex);
});

let autoplayTimeout2;

coSwiperOn(coS2Swiper2, 'touchStart', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coSwiperOn(coS2Swiper2, 'touchMove', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coSwiperOn(coS2Swiper2, 'sliderMove', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coSwiperOn(coS2Swiper2, 'touchEnd', () => {
  clearTimeout(autoplayTimeout2);
  autoplayTimeout2 = setTimeout(() => {
    coAutoplay(coS2Swiper1, 'start');
  }, autoplayDelay2);
});

coSwiperOn(coS2Swiper3, 'touchStart', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coSwiperOn(coS2Swiper3, 'touchMove', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coSwiperOn(coS2Swiper3, 'sliderMove', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coSwiperOn(coS2Swiper3, 'touchEnd', () => {
  clearTimeout(autoplayTimeout2);
  autoplayTimeout2 = setTimeout(() => {
    coAutoplay(coS2Swiper1, 'start');
  }, autoplayDelay2);
});

coOn('.co-home-2-slider-2', 'mousedown', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coOn('.co-home-2-slider-3', 'mousedown', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coOn('.co-home-2-slider-2', 'mouseenter', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coOn('.co-home-2-slider-3', 'mouseenter', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

coOn('.co-home-2-slider-2', 'mouseleave', () => {
  clearTimeout(autoplayTimeout2);
  autoplayTimeout2 = setTimeout(() => {
    coAutoplay(coS2Swiper1, 'start');
  }, autoplayDelay2);
});

coOn('.co-home-2-slider-3', 'mouseleave', () => {
  clearTimeout(autoplayTimeout2);
  autoplayTimeout2 = setTimeout(() => {
    coAutoplay(coS2Swiper1, 'start');
  }, autoplayDelay2);
});

const iframes = document.querySelectorAll('.co-home-2-slider-2 iframe');
iframes.forEach(iframe => {
  iframe.addEventListener('mouseenter', () => {
    coAutoplay(coS2Swiper1, 'stop');
    clearTimeout(autoplayTimeout2);
  });
  
  iframe.addEventListener('mouseleave', () => {
    clearTimeout(autoplayTimeout2);
    autoplayTimeout2 = setTimeout(() => {
      coAutoplay(coS2Swiper1, 'start');
    }, autoplayDelay2);
  });
  
  iframe.addEventListener('focus', () => {
    coAutoplay(coS2Swiper1, 'stop');
    clearTimeout(autoplayTimeout2);
  });
  
  iframe.addEventListener('blur', () => {
    clearTimeout(autoplayTimeout2);
    autoplayTimeout2 = setTimeout(() => {
      coAutoplay(coS2Swiper1, 'start');
    }, autoplayDelay2);
  });
});

window.addEventListener('blur', () => {
  coAutoplay(coS2Swiper1, 'stop');
  clearTimeout(autoplayTimeout2);
});

window.addEventListener('focus', () => {
  clearTimeout(autoplayTimeout2);
  autoplayTimeout2 = setTimeout(() => {
    coAutoplay(coS2Swiper1, 'start');
  }, autoplayDelay2);
});

// ========================================================================================== SECTION 3
const autoplayDelay3 = 0;

const coS3Swiper1 = new Swiper('.co-home-3-slider-1', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 400,
  loop: true,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  watchSlidesProgress: true,
  mousewheel: {
    forceToAxis: true,
  },
});

const coS3Swiper2 = new Swiper('.co-home-3-slider-2', {
  slidesPerView: 1,
  speed: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: true,
});

const coS3Swiper3 = new Swiper('.co-home-3-slider-3', {
  slidesPerView: 1,
  speed: 400,
  effect: 'fade',
  watchSlidesProgress: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: false,
});

coSwiperOn(coS3Swiper1, 'slideChange', () => {
  if (!coSwiperReady(coS3Swiper2) || !coSwiperReady(coS3Swiper3)) return;
  const mainIndex = coS3Swiper1.realIndex;
  const totalSlider2Slides = coS3Swiper2.slides.length;
  const recycledIndex = mainIndex % totalSlider2Slides;
  coS3Swiper2.slideToLoop(recycledIndex);
  coS3Swiper3.slideToLoop(mainIndex);
});

let autoplayTimeout3;

coSwiperOn(coS3Swiper2, 'touchStart', () => {
  coAutoplay(coS3Swiper1, 'stop');
  clearTimeout(autoplayTimeout3);
});

coSwiperOn(coS3Swiper2, 'touchMove', () => {
  coAutoplay(coS3Swiper1, 'stop');
  clearTimeout(autoplayTimeout3);
});

coSwiperOn(coS3Swiper2, 'sliderMove', () => {
  coAutoplay(coS3Swiper1, 'stop');
  clearTimeout(autoplayTimeout3);
});

coSwiperOn(coS3Swiper2, 'touchEnd', () => {
  clearTimeout(autoplayTimeout3);
  autoplayTimeout3 = setTimeout(() => {
    coAutoplay(coS3Swiper1, 'start');
  }, autoplayDelay3);
});

coOn('.co-home-3-slider-2', 'mousedown', () => {
  coAutoplay(coS3Swiper1, 'stop');
  clearTimeout(autoplayTimeout3);
});

coOn('.co-home-3-slider-2', 'mouseenter', () => {
  coAutoplay(coS3Swiper1, 'stop');
  clearTimeout(autoplayTimeout3);
});

coOn('.co-home-3-slider-2', 'mouseleave', () => {
  clearTimeout(autoplayTimeout3);
  autoplayTimeout3 = setTimeout(() => {
    coAutoplay(coS3Swiper1, 'start');
  }, autoplayDelay3);
});

const iframes3 = document.querySelectorAll('.co-home-3-slider-2 iframe');
iframes3.forEach(iframe => {
  iframe.addEventListener('mouseenter', () => {
    coAutoplay(coS3Swiper1, 'stop');
    clearTimeout(autoplayTimeout3);
  });
  
  iframe.addEventListener('mouseleave', () => {
    clearTimeout(autoplayTimeout3);
    autoplayTimeout3 = setTimeout(() => {
      coAutoplay(coS3Swiper1, 'start');
    }, autoplayDelay3);
  });
  
  iframe.addEventListener('focus', () => {
    coAutoplay(coS3Swiper1, 'stop');
    clearTimeout(autoplayTimeout3);
  });
  
  iframe.addEventListener('blur', () => {
    clearTimeout(autoplayTimeout3);
    autoplayTimeout3 = setTimeout(() => {
      coAutoplay(coS3Swiper1, 'start');
    }, autoplayDelay3);
  });
});

window.addEventListener('blur', () => {
  coAutoplay(coS3Swiper1, 'stop');
  clearTimeout(autoplayTimeout3);
});

window.addEventListener('focus', () => {
  clearTimeout(autoplayTimeout3);
  autoplayTimeout3 = setTimeout(() => {
    coAutoplay(coS3Swiper1, 'start');
  }, autoplayDelay3);
});
// ========================================================================================== SECTION 4
const cH4Swiper1 = new Swiper('.co-home-4-slider-1', {
  slidesPerView: "auto",
  spaceBetween: 0,
  speed: 400,
  loop: true,
  slideToClickedSlide: true,
  centeredSlides: true,
  // loopedSlides: 20,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.co-home-4-swiper-button-next',
    prevEl: '.co-home-4-swiper-button-prev',
  },
  mousewheel: {
    forceToAxis: true,
  },
});
const cH4Swiper2 = new Swiper('.co-home-4-slider-2', {
  slidesPerView: 1,
  // autoHeight: true,
  speed: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: false,
});
coSwiperOn(cH4Swiper1, 'slideChange', () => {
  cH4Swiper2.slideToLoop(cH4Swiper1.realIndex);
});
// ========================================================================================== SECTION 7
const coH7ScrollTRIGGER = '.co-home-7';
const coH7ScrollSTART = '-25% bottom';
const coH7ScrollEND = '125% top';
function getUpdatedMotionPath() {
  return {
    immediateRender: true,
    path: "#co-home-7-wave-svg-path-id",
    align: "#co-home-7-wave-svg-path-id",
    autoRotate: true,
    alignOrigin: [0.5, 0],
    start: 1,
    end: 0,
  };
}
function initializeMotionPath() {
  // gsap.set('.co-home-7-cow-1', { rotateX: 180, top: "-2vw" });
  const coHomeSection2MotionPath = getUpdatedMotionPath();
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: 1,
    },
  });
  tl.to('.co-home-7-cow', {
    motionPath: coHomeSection2MotionPath,
  });
  const progressTimeline1 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline2 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline3 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline4 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline5 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline6 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  // LEG 1
  let coHome7CowFrontLeg1START = 35;
  let coHome7CowFrontLeg1END = -35;
  progressTimeline1.set('.co-home-7-cow-front-leg-1', { rotate: coHome7CowFrontLeg1START });
  for (let i = 0; i < 6; i++) {
    progressTimeline1.to('.co-home-7-cow-front-leg-1', { rotate: coHome7CowFrontLeg1END });
    progressTimeline1.to('.co-home-7-cow-front-leg-1', { rotate: coHome7CowFrontLeg1START });
  }
  // LEG 2
  let coHome7CowFrontLeg2START = -35;
  let coHome7CowFrontLeg2END = 35;
  progressTimeline2.set('.co-home-7-cow-front-leg-2', { rotate: coHome7CowFrontLeg2START });
  for (let i = 0; i < 6; i++) {
    progressTimeline2.to('.co-home-7-cow-front-leg-2', { rotate: coHome7CowFrontLeg2END });
    progressTimeline2.to('.co-home-7-cow-front-leg-2', { rotate: coHome7CowFrontLeg2START });
  }
  // LEG 3
  let coHome7CowRearLeg1START = -35;
  let coHome7CowRearLeg1END = 35;
  progressTimeline3.set('.co-home-7-cow-rear-leg-1', { rotate: coHome7CowRearLeg1START });
  for (let i = 0; i < 6; i++) {
    progressTimeline3.to('.co-home-7-cow-rear-leg-1', { rotate: coHome7CowRearLeg1END });
    progressTimeline3.to('.co-home-7-cow-rear-leg-1', { rotate: coHome7CowRearLeg1START });
  }
  // LEG 4
  let coHome7CowRearLeg2START = 35;
  let coHome7CowRearLeg2END = -35;
  progressTimeline4.set('.co-home-7-cow-rear-leg-2', { rotate: coHome7CowRearLeg2START });
  for (let i = 0; i < 6; i++) {
    progressTimeline4.to('.co-home-7-cow-rear-leg-2', { rotate: coHome7CowRearLeg2END });
    progressTimeline4.to('.co-home-7-cow-rear-leg-2', { rotate: coHome7CowRearLeg2START });
  }
  // TAIL
  let coHome7CowTailSTART = 15;
  let coHome7CowTailEND = -5;
  progressTimeline5.set('.co-home-7-cow-tail', { rotate: coHome7CowTailSTART });
  for (let i = 0; i < 9; i++) {
    progressTimeline5.to('.co-home-7-cow-tail', { rotate: coHome7CowTailEND });
    progressTimeline5.to('.co-home-7-cow-tail', { rotate: coHome7CowTailSTART });
  }
  // BODY
  let coHome7Cow2START = "-0.8vw";
  let coHome7Cow2END = "0.8vw";
  progressTimeline6.set('.co-home-7-cow-2', { y: coHome7Cow2START });
  for (let i = 0; i < 10; i++) {
    progressTimeline6.to('.co-home-7-cow-2', { y: coHome7Cow2END });
    progressTimeline6.to('.co-home-7-cow-2', { y: coHome7Cow2START });
  }
  
  ScrollTrigger.create({
    trigger: coH7ScrollTRIGGER,
    start: coH7ScrollSTART,
    end: coH7ScrollEND,
    onUpdate: (self) => {
      self.direction === -1 ? coMotionPathFlipLeft() : coMotionPathFlipRight();
    },
  });
}

function coMotionPathFlipRight() {
  gsap.to(".co-home-7-cow-1", { rotateY: 0, duration: 0.1 });
}

function coMotionPathFlipLeft() {
  gsap.to(".co-home-7-cow-1", { rotateY: 180, duration: 0.1 });
}

initializeMotionPath();

window.addEventListener('resize', () => {
  initializeMotionPath();
  ScrollTrigger.refresh();
});
// ========================================================================================== SECTION 8
const cH8Swiper1 = new Swiper('.co-home-8-slider-1', {
  slidesPerView: "auto",
  spaceBetween: 0,
  speed: 400,
  loop: true,
  centeredSlides: true,
  slideToClickedSlide: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.co-home-8-swiper-button-next',
    prevEl: '.co-home-8-swiper-button-prev',
  },
  mousewheel: {
    forceToAxis: true,
  },
  on: {
    init: function() {
      updateSlideClassesWithLoop(this);
    },
    slideChange: function() {
      updateSlideClassesWithLoop(this);
    }
  }
});
const cP2Swiper2 = new Swiper('.co-home-8-slider-2', {
  slidesPerView: 1,
  autoHeight: false,
  speed: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: false,
});
function updateSlideClassesWithLoop(swiperInstance) {
  const slides = swiperInstance.slides;
  const activeIndex = swiperInstance.activeIndex;
  const slidesLength = slides.length;
  slides.forEach(slide => {
    slide.classList.remove(
      'co-next-1', 'co-next-2', 'co-next-3', 
      'co-prev-1', 'co-prev-2', 'co-prev-3'
    );
  });
  for (let i = 1; i <= 3; i++) {
    let nextIndex = activeIndex + i;
    if (nextIndex >= slidesLength) nextIndex = nextIndex - slidesLength;
    if (slides[nextIndex]) {
      slides[nextIndex].classList.add(`co-next-${i}`);
    }
  }
  for (let i = 1; i <= 3; i++) {
    let prevIndex = activeIndex - i;
    if (prevIndex < 0) prevIndex = prevIndex + slidesLength;
    if (slides[prevIndex]) {
      slides[prevIndex].classList.add(`co-prev-${i}`);
    }
  }
}
coSwiperOn(cH8Swiper1, 'slideChange', () => {
  cP2Swiper2.slideToLoop(cH8Swiper1.realIndex);
});
// ========================================================================================== SECTION 9
function coGetUpdatedMotionPath2() {
  return {
    immediateRender: true,
    path: "#co-home-9-wave-svg-path-id",
    align: "#co-home-9-wave-svg-path-id",
    autoRotate: true,
    alignOrigin: [0.5, 0],
    start: 0,
    end: 1,
  };
}
function coInitializeMotionPath2() {
  const coHomeS9MotionPath = coGetUpdatedMotionPath2();
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: 1,
    },
  });
  tl.to('.co-home-9-person', {
    motionPath: coHomeS9MotionPath,
  });
  const coProgressTimeline1 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const coProgressTimeline2 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const coProgressTimeline3 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const coProgressTimeline4 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const coProgressTimeline5 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const coProgressTimeline6 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const coProgressTimeline7 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: '.co-home-9',
      start: 'top bottom',
      end: "bottom top",
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  // FULL
  let coH9PersonFullSTART = "-0.25vw";
  let coH9PersonFullEND = "0.25vw";
  coProgressTimeline1.set('.co-home-9-person-2', { y: coH9PersonFullSTART });
  for (let i = 0; i < 4; i++) {
    coProgressTimeline1.to('.co-home-9-person-2', { y: coH9PersonFullEND });
    coProgressTimeline1.to('.co-home-9-person-2', { y: coH9PersonFullSTART });
  }
  // LEG1
  let coH9PersonLeg1START = "10deg";
  let coH9PersonLeg1END = "-40deg";
  let coH9PersonLeg1YSTART = "0vw";
  let coH9PersonLeg1YEND = "1vw";
  coProgressTimeline2.set('.co-home-9-leg-1', { rotate: coH9PersonLeg1START, y: coH9PersonLeg1YSTART });
  for (let i = 0; i < 4; i++) {
    coProgressTimeline2.to('.co-home-9-leg-1', { rotate: coH9PersonLeg1END, y: coH9PersonLeg1YEND });
    coProgressTimeline2.to('.co-home-9-leg-1', { rotate: coH9PersonLeg1START, y: coH9PersonLeg1YSTART });
  }
  // LEG2
  let coH9PersonLeg2START = "-5deg";
  let coH9PersonLeg2END = "25deg";
  let coH9PersonLeg2YSTART = "0vw";
  let coH9PersonLeg2YEND = "-0.25vw";
  coProgressTimeline3.set('.co-home-9-leg-2', { rotate: coH9PersonLeg2START, y: coH9PersonLeg2YSTART });
  for (let i = 0; i < 4; i++) {
    coProgressTimeline3.to('.co-home-9-leg-2', { rotate: coH9PersonLeg2END, y: coH9PersonLeg2YEND });
    coProgressTimeline3.to('.co-home-9-leg-2', { rotate: coH9PersonLeg2START, y: coH9PersonLeg2YSTART });
  }
  // ARM1
  let coH9PersonArm1START = "-15deg";
  let coH9PersonArm1END = "5deg";
  coProgressTimeline4.set('.co-home-9-arm-1', { rotate: coH9PersonArm1START });
  for (let i = 0; i < 3; i++) {
    coProgressTimeline4.to('.co-home-9-arm-1', { rotate: coH9PersonArm1END });
    coProgressTimeline4.to('.co-home-9-arm-1', { rotate: coH9PersonArm1START });
  }
  // ARM2
  let coH9PersonArm2START = "5deg";
  let coH9PersonArm2END = "-10deg";
  coProgressTimeline5.set('.co-home-9-arm-2', { rotate: coH9PersonArm2START });
  for (let i = 0; i < 3; i++) {
    coProgressTimeline5.to('.co-home-9-arm-2', { rotate: coH9PersonArm2END });
    coProgressTimeline5.to('.co-home-9-arm-2', { rotate: coH9PersonArm2START });
  }
  // ARM3
  let coH9PersonArm3START = "-10deg";
  let coH9PersonArm3END = "10deg";
  coProgressTimeline6.set('.co-home-9-arm-3', { rotate: coH9PersonArm3START });
  for (let i = 0; i < 4; i++) {
    coProgressTimeline6.to('.co-home-9-arm-3', { rotate: coH9PersonArm3END });
    coProgressTimeline6.to('.co-home-9-arm-3', { rotate: coH9PersonArm3START });
  }
  // ARM4
  let coH9PersonArm4START = "10deg";
  let coH9PersonArm4END = "-10deg";
  coProgressTimeline7.set('.co-home-9-arm-4', { rotate: coH9PersonArm4START });
  for (let i = 0; i < 4; i++) {
    coProgressTimeline7.to('.co-home-9-arm-4', { rotate: coH9PersonArm4END });
    coProgressTimeline7.to('.co-home-9-arm-4', { rotate: coH9PersonArm4START });
  }
  // –
  ScrollTrigger.create({
    trigger: '.co-home-9',
    start: 'top bottom',
    end: "bottom top",
    onUpdate: (self) => {
      self.direction === -1 ? coH9MotionPathFlipLeft() : coH9MotionPathFlipRight();
    },
  });
}
function coH9MotionPathFlipRight() {
  gsap.to(".co-home-9-person-1", { rotateY: 0, duration: 0.1 });
}
function coH9MotionPathFlipLeft() {
  gsap.to(".co-home-9-person-1", { rotateY: 180, duration: 0.1 });
}
coInitializeMotionPath2();
window.addEventListener('resize', () => {
  coInitializeMotionPath2();
  ScrollTrigger.refresh();
});

// ========================================================================================== WHERE TO BUY
// // Get all parent containers to work with related elements
// const coFooterContainers = document.querySelectorAll('.co-home-2-where-to-buy');

// // Store observers to manage them
// const coFooterObservers = [];

// // Create observer callback
// const coFooterObserverCallback = function(mutationsList, observer) {
//     for (let mutation of mutationsList) {
//         if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//             // Find the container that this target element belongs to
//             const container = mutation.target.closest('.co-home-2-where-to-buy');
//             yourActionFunction(container);
//             observer.disconnect();
            
//             // Remove this observer from our tracking array
//             const observerIndex = coFooterObservers.indexOf(observer);
//             if (observerIndex > -1) {
//                 coFooterObservers.splice(observerIndex, 1);
//             }
//         }
//     }
// };

// // Create observers for each container's target element
// coFooterContainers.forEach((container) => {
//     const targetElement = container.querySelector('.co-home-2-where-to-buy-embed > div');
//     if (targetElement) {
//         const observer = new MutationObserver(coFooterObserverCallback);
//         observer.observe(targetElement, { childList: true });
//         coFooterObservers.push(observer);
//     }
// });

// // Modified action function to handle specific container
// function yourActionFunction(container) {
//     const loaderElement = container.querySelector('.co-home-2-where-to-buy-embed-loading');
//     const embedElement = container.querySelector('.co-home-2-where-to-buy-embed');
    
//     if (loaderElement) {
//         loaderElement.classList.add('co-loaded');
//     }
//     if (embedElement) {
//         embedElement.classList.add('co-loaded');
//     }
// }
